import { cutToast } from 'utility/toast';
import { useMutation } from '@apollo/client';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import {
  EntityDocumentDelete,
  EntityDocumentDeleteVariables,
} from 'common/graphql/__generated__/EntityDocumentDelete';
import { EntityDeleteInput } from 'common/types/globalTypes';
import { EntityType } from 'common/types/utility';
import React from 'react';

import { DocumentListItem } from '../interface';
import DOCUMENT_DELETE from 'common/graphql/EntityDocumentDelete.graphql';

interface DeleteModalProps {
  onDeletion: () => void;
  selectedDocuments: DocumentListItem[];
}
export const DeleteModal: React.FC<DeleteModalProps> = ({
  onDeletion,
  selectedDocuments,
}) => {
  const [deleteDocuments] = useMutation<
    EntityDocumentDelete,
    EntityDocumentDeleteVariables
  >(DOCUMENT_DELETE, { errorPolicy: 'all' });

  const _onConfirm = async () => {
    const entities = selectedDocuments.filter((i) => i._isDeletable);

    if (entities.length) {
      const entityDelete = entities.map(
        (i) =>
          ({ id: i.id, rowTimestamp: i._rowTimestamp }) as EntityDeleteInput
      );
      const { errors } = await deleteDocuments({
        variables: {
          input: {
            entityDelete,
          },
        },
        update(cache, { data: response }) {
          response?.entityDocumentDelete?.deletedEntities?.forEach((item) => {
            const identity = `EntityDocument:${item?.id}`;
            cache.evict({ id: identity });
            cache.gc();
          });
        },
      });

      if (errors?.length) {
        cutToast.error(errors[0].message);
      } else {
        cutToast.success('Documents deleted successfully');
      }
    }
  };

  return (
    <>
      {selectedDocuments.length > 0 && (
        <ActionMessageModal
          entityType={EntityType.Document}
          disabled={
            !selectedDocuments.some((selected) => selected._isDeletable)
          }
          visible={selectedDocuments.length > 0}
          multiple={{
            validCount: selectedDocuments.filter(
              (selected) => selected._isDeletable
            ).length,
            invalidNames: selectedDocuments
              .filter((selected) => !selected._isDeletable)
              .map((cannotDelete) => cannotDelete.fileReference),
          }}
          onConfirm={_onConfirm}
        />
      )}
    </>
  );
};
